<div class="flex! flex-row! flex-nowrap! w-full! gap-3 items-stretch">

  <ng-container *ngIf="!isLoading()">
    <div *ngFor="let item of stats()"
         class="bg-white p-3 xl:p-4 rounded-md shadow-sm border border-gray-100 flex! flex-row! items-center justify-between h-[93px] flex-1! min-w-0">

      <div class="flex flex-col justify-center min-w-0 overflow-hidden mr-1">
        <typography variant="body-2" weight="semibold"
          class="text-black! tracking-tighter text-[11px] xl:text-[13px] leading-tight block whitespace-nowrap">
          {{ item.label }}
        </typography>
        <typography weight="semibold"
          class="text-black! text-2xl xl:text-3xl leading-none! -mt-1!">
          {{ item.value }}
        </typography>
      </div>

      <div class="w-9! h-9! xl:w-11! xl:h-11! rounded-full! bg-black! flex! items-center! justify-center! shrink-0 shadow-sm ml-1">
        <i [class]="item.icon + ' text-yellow-500! text-base xl:text-lg'"></i>
      </div>

    </div>
  </ng-container>

  <ng-container *ngIf="isLoading()">
    <div *ngFor="let i of [1,2,3,4]"
         class="flex-1! h-[93px] bg-gray-50 animate-pulse rounded-lg border border-gray-100">
    </div>
  </ng-container>
</div>
